
import { Component, InjectReactive, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

import OrderHistoryComponent from '@/components/OrderHistory.vue';
import SingleFavorite from '@/components/SingleFavorite.vue';
import SingleOrder from '@/components/SingleOrder.vue';
import { Views } from '@/enums';
import UserModule from '@/store/modules/user';
import { hideCMSContent } from '@/utils/global.util';

@Component({
  components: {
    'order-history': OrderHistoryComponent,
    SingleFavorite,
    SingleOrder,
  }
})
export default class OrderHistory extends Vue {
  @InjectReactive('progressRef') progressRef: any;
  @Getter activeRestaurant!: Restaurant;
  previewOrderHistory: OrderModel | null;
  previewFavoriteOrder: FavoriteOrderModel | null;
  showHistory: boolean;

  data() {
    return {
      previewOrderHistory: null,
      previewFavoriteOrder: null,
      showHistory: true,
    }
  }

  get isLoggedIn() {
    return UserModule.loggedIn;
  }

  get orderHistory() {
    return UserModule.orderHistory;
  }

  get favoriteOrders() {
    return UserModule.favoriteOrders;
  }

  handleClickOrderHistory() {
    this.showHistory = true;
  }

  handleClickFavorites() {
    this.showHistory = false;
  }

  handleReOrder() {
    hideCMSContent();
    this.$router.push({
      name: Views.ORDER_SUMMARY,
      params: {
        location: this.activeRestaurant.slug,
      }
    });
  }

  handlePreviewFavoriteOrder(order) {
    this.previewFavoriteOrder = order;
    this.$scrollTo(this.$refs.container as Element);
  }

  handlePreviewOrderHistory(order) {
    this.previewOrderHistory = order;
    this.$scrollTo(this.$refs.container as Element);
  }
}
